/**
 * Anrede, Vorname, Nachname — und darunter die fertige erste Zeile des
 * Anschreibens (Migration 164/170, 24.09.2026).
 *
 * Ersetzt beim Privatkunden das Namensfeld: den Namen gibt man einmal ein,
 * `kunde.name` baut Kontor daraus (lib/anrede.ts `kundenName`). Dieselbe
 * Eingabe dient den Ansprechpartnern einer Firma (KontaktListen.tsx), dort
 * ohne „Familie" und „Frau und Herr".
 *
 * Eigenständig gestylt (styles/kunden.css, `k-anrede`), weil es in mehreren
 * Formularen steht: Kundenseite, Anlege-Dialog, Ansprechpartner.
 */
import { ANREDE_LABEL, PRIVAT_ANREDEN, anredeZeile, type Anrede } from "../../lib/anrede";
import "../../styles/kunden.css";

type Props = {
  anrede: string;
  vorname: string;
  nachname: string;
  onChange: (werte: { anrede: Anrede; vorname: string; nachname: string }) => void;
  /** Welche Anreden zur Wahl stehen — Standard: die eines Privatkunden. */
  anreden?: readonly Anrede[];
  /** Für Ansprechpartner: „Neutral" statt „Unbekannt (neutral)" usw. */
  label?: Partial<Record<Anrede, string>>;
  autoFocus?: boolean;
};

export default function AnredeFeld({ anrede, vorname, nachname, onChange, anreden = PRIVAT_ANREDEN, label = {}, autoFocus }: Props) {
  const art: Anrede = (anreden as readonly string[]).includes(anrede) ? (anrede as Anrede) : "";
  const werte = { anrede: art, vorname, nachname };
  const zeile = anredeZeile({ anrede: art, vorname, nachname, name: `${vorname} ${nachname}`, kundentyp: "privat" });
  return (
    <div className="k-anrede">
      <div className="k-anrede-felder">
        <label>
          <span>Anrede</span>
          <select value={art} onChange={(e) => onChange({ ...werte, anrede: e.target.value as Anrede })}>
            {anreden.map((a) => <option key={a} value={a}>{label[a] ?? ANREDE_LABEL[a]}</option>)}
          </select>
        </label>
        <label>
          <span>Vorname</span>
          <input
            value={vorname} autoFocus={autoFocus}
            placeholder={art === "paar" ? "z. B. Andrea + Michael" : ""}
            onChange={(e) => onChange({ ...werte, vorname: e.target.value })}
          />
        </label>
        <label>
          <span>Nachname</span>
          <input value={nachname} onChange={(e) => onChange({ ...werte, nachname: e.target.value })} />
        </label>
      </div>
      {(vorname.trim() || nachname.trim()) && (
        <p className="k-anrede-vorschau">Im Anschreiben: <strong>{zeile},</strong></p>
      )}
    </div>
  );
}
